import { render, staticRenderFns } from "./UpdateGalleryImage.vue?vue&type=template&id=64189e5c"
import script from "./UpdateGalleryImage.vue?vue&type=script&lang=js"
export * from "./UpdateGalleryImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports